
import Vue from "vue";
export default Vue.extend({
  props: {
    validations: {
      type: Object,
    },
  },
  computed: {
    itemTitle: {
      get(): string {
        return (this as any).$store.getters.folderUpdateForm.structureItemTitle;
      },
      set(structureItemTitle: string) {
        (this as any).$store.dispatch("setFolderUpdateForm", {
          ...(this as any).$store.getters.folderUpdateForm,
          structureItemTitle,
        });
      },
    },
    itemTitleError() {
      return (this as any).validations.structureItemTitle.$error ? "Folder Name is required." : "";
    },
  },
});
